import { render, staticRenderFns } from "./wfList.vue?vue&type=template&id=822851a8&scoped=true&"
import script from "./wfList.vue?vue&type=script&lang=js&"
export * from "./wfList.vue?vue&type=script&lang=js&"
import style0 from "./wfList.vue?vue&type=style&index=0&id=822851a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822851a8",
  null
  
)

export default component.exports